<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content work-order-form-page create-from-procedure-page">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>

          <div class="col-md-10">
            <div class="card-body">
              <card-section-header
                title="Procedure Details"
                icon="fas fa-edit">
              </card-section-header>
              <h5 class="create-from-procedure-subtitle">
                Create Work Order From Procedure: {{ selectedProcedure?.name }}
              </h5>

              <form *ngIf="!saveInProgress" [formGroup]="form" (ngSubmit)="submit()">
                <ng-container *ngIf="!pageLoading; else formSkeleton">
                <div class="row form-row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Purpose of Work Order <span class="required-text">(required)</span></label>
                      <textarea type="text" class="form-control sl-textarea"
                        formControlName="purpose"
                        placeholder="Add extra detail around purpose of work order...">
                      </textarea>
                    </div>
                  </div>
                </div>

                <div class="row form-row">
                  <div class="col-md-12" *ngIf="siteAssets.length">
                    <div class="form-group">
                      <label>Asset <span class="required-text">(required)</span></label>
                      <p-dropdown
                        class="form-control sl-input"
                        formControlName="asset"
                        [options]="procedureAssets"
                        optionLabel="label"
                        placeholder="Select asset for work order..."
                        [style]="{ width: '100%' }"
                        filter="true"
                        (onChange)="selectedAssetChange($event)">
                      </p-dropdown>
                    </div>
                  </div>
                </div>

                <div class="row form-row" *ngIf="hasSelectedAsset">
                  <div class="col-md-12">
                    <div class="create-from-procedure-asset-summary">
                      <p class="create-from-procedure-asset-summary__title">Selected Asset Details</p>
                      <p class="create-from-procedure-asset-summary__item">
                        <strong>OEM:</strong> {{ selectedAssetOem || 'N/A' }}
                      </p>
                      <p class="create-from-procedure-asset-summary__item">
                        <strong>Model:</strong> {{ selectedAssetModel || 'N/A' }}
                      </p>
                      <p class="create-from-procedure-asset-summary__item">
                        <strong>Rating:</strong> {{ selectedAssetRating || 'N/A' }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row form-row text-center" *ngIf="allowAssetScheduling && exemptFromAssetScheduling">
                  <div class="col-md-12">
                    <div class="alert alert-secondary" role="alert">Asset exempt from schedule</div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="allowWorkOrderScheduling">
                  <div class="col-md-6" >
                    <div class="form-group">
                      <label>Scheduled Start Time</label>
                      <p-calendar class="form-control sl-input"
                        formControlName="scheduledStartTime"
                        dateFormat="dd/mm/yy"
                        [showTime]="true" [hideOnDateTimeSelect]="false"
                        [minDate]="minDate"
                        panelStyleClass="popupAboveDate"
                        placeholder="Select schedule start time...">
                      </p-calendar>
                    </div>
                  </div>
                  <div class="col-md-6" >
                    <div class="form-group">
                      <label>Scheduled End Time</label>
                      <p-calendar class="form-control sl-input"
                        formControlName="scheduledEndTime"
                        dateFormat="dd/mm/yy"
                        [showTime]="true" [hideOnDateTimeSelect]="false"
                        [minDate]="minDate"
                        panelStyleClass="popupAboveDate"
                        placeholder="Select schedule end time...">
                      </p-calendar>
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="allowAssetScheduling && !exemptFromAssetScheduling">
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label>Make Work Order exempt from asset availability schedule</label>
                      <p-checkbox class="form-control" formControlName="exemptFromAssetScheduling" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="!selectedProcedure.preapproved">
                  <div class="col-md-12">
                    <div class="form-group form-group-checkbox">
                      <label for="overrideApproval">Approve & Release Work Order Immediately?</label>
                      <p-checkbox class="form-control" inputId="overrideApproval" formControlName="overrideApproval" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="selectedProcedure.preapproved">
                  <div class="col-md-12">
                    <div class="alert alert-info create-from-procedure-model-note" role="alert">
                      This procedure is preapproved and will be released immediately
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="showTurbineModelSelection">
                  <div class="col-md-12">
                    <div class="create-from-procedure-model-card">
                      <p class="create-from-procedure-model-card__intro">
                        This procedure requires a competency:
                        <strong>{{ turbineCompetencySummary }}</strong>
                      </p>
                      <p class="create-from-procedure-model-card__title">
                        Please confirm the specific model for this turbine:
                      </p>
                      <div class="form-group create-from-procedure-model-card__field">
                        <label>Model Version:</label>
                        <p-dropdown
                          class="form-control sl-input"
                          formControlName="modelVersion"
                          [options]="turbineModelOptions"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Select a model"
                          [style]="{ width: '100%' }">
                        </p-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row form-row" *ngIf="turbineModelResolutionMessage">
                  <div class="col-md-12">
                    <div class="alert alert-info create-from-procedure-model-note" role="alert">
                      {{ turbineModelResolutionMessage }}
                    </div>
                  </div>
                </div>
                <div *ngIf="validationErrors.length" class="validation-box text-danger">
                  <strong>Please fix the following validation problems to continue:</strong>
                  <div *ngFor="let validationError of validationErrors">- {{validationError.message}}</div>
                  <br>
                </div>
                </ng-container>
                <ng-template #formSkeleton>
                  <div class="row form-row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <skeleton-loading-field variant="textarea"></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                  <div class="row form-row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </form>
              <div *ngIf="saveInProgress" style="text-align: center;">
                <p-progressSpinner></p-progressSpinner>
              </div>
              <div *ngIf="!saveInProgress" class="work-order-form-actions">
                <button type="button" (click)="submit()" [disabled]="!form.valid || saveInProgress" class="btn btn-success btn-round work-order-submit">Create Work Order</button>
                <button type="button" (click)="navigateBackToList()" class="btn btn-link btn-link-cancel">
                  <i class="fas fa-times"></i>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
